import React from 'react';
import { RecipesSection } from '../RecipesSection';
import { TextureCloseup } from '../TextureCloseup';
import { SectionLink } from '../SectionLink';

/**
 * Recipes page — opens with the "cooking at home" header (a photograph of a
 * tray of biscuit rounds mid-bake, shot on the home counter), then the
 * cookbook grouped by meal occasion (Breakfast / Lunch / Dinner / Dessert).
 */
export function RecipesPage() {
  return (
    <>
      <section className="section fade-in" style={{ paddingBottom: '2.5rem' }}>
        <div className="section-label">In your kitchen</div>
        <h2>Cooking at home with TrueNooch</h2>
        <p style={{ maxWidth: '54ch' }}>
          It’s a whole food, so it cooks like one — cold on a sandwich, browned in a pan, or worked
          into dough. The same round of TrueNooch™ you’d set on a cracker ends up in the cookies.
          Twelve recipes below, all of them made in a home kitchen.
        </p>
        {/* Photograph, not a render: 640x480 off a phone, where .macro-banner's
            380px max-height + object-fit:cover is built for the 3:2 renders and
            would crop away the bottom two rows of the tray. Height is uncapped
            here so the whole frame shows. */}
        <div className="macro-banner" style={{ maxWidth: 920, margin: '1.75rem 0 0' }}>
          <img
            style={{ maxHeight: 'none' }}
            src={`${process.env.PUBLIC_URL}/images/recipes/truenooch-biscuits.webp`}
            alt="A home kitchen counter: a tray of unbaked TrueNooch™ biscuit rounds on a lined sheet pan, with a rolling pin, a stand-mixer bowl and a jar of TrueNooch™ cubes behind it."
            loading="eager"
          />
        </div>
      </section>
      <RecipesSection />
      <TextureCloseup />
      <section className="section fade-in" style={{ paddingTop: '1rem', paddingBottom: '4rem' }}>
        <SectionLink to="/nutrition">Why it’s this good</SectionLink>
      </section>
    </>
  );
}
